<template>
  <i-modal
    class="modal-search-area"
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="地域検索"
    width="600"
    footer-hide
  >
    <div>
      <i-tab :value="tabValue" @on-click="onClickSettingTab">
        <!--エリア選択タブ-->
        <i-tab-panel label="エリア選択" name="pref">
          <div v-if="modalLoading" class="loading-container">
            <i-spin fix />
          </div>
          <div v-else class="list_wrap">
            <template v-for="(areaItem, areaIndex) in prefs">
              <i-button
                :key="areaIndex"
                type="primary"
                shape="circle"
                size="small"
                @click="onClickArea(areaItem.pref_cd)"
                :ghost="selected.prefs.indexOf(areaItem.pref_cd) === -1"
                style="margin-bottom: 4px; margin-right: 4px;"
              >
                {{ areaItem.pref_name }}
              </i-button>
            </template>
          </div>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onCancel">
              キャンセル
            </i-button>
            <i-button
              type="primary"
              :disabled="!selected.prefs.length"
              style="margin-right: 8px;"
              @click="onClickSearch"
            >
              選択エリアの全物件を表示
            </i-button>
            <i-button type="primary" :disabled="!selected.prefs.length" @click="onClickSearchCity">
              市区郡を絞り込み
            </i-button>
          </div>
        </i-tab-panel>

        <!--市区郡選択タブ-->
        <i-tab-panel label="市区郡選択" :disabled="tabDisabledShiku" name="shiku">
          <div v-if="modalLoading" class="loading-container">
            <i-spin fix />
          </div>
          <template v-else>
            <div style="padding-bottom: 16px;">
              <i-input
                size="small"
                search
                style="width: 200px;"
                v-model="inputSuggestShiku"
                @on-keyup="onKeyupSuggestShiku"
                @on-keydown="onKeydownSuggestShiku"
              />
              <transition>
                <span class="suggest-spin-col" v-show="loadingSuggestShiku">
                  <i-spin>
                    <i-icon type="ios-loading" size="14" class="suggest-spin-icon-load" />
                  </i-spin>
                </span>
              </transition>
            </div>
            <div class="list_wrap">
              <template v-for="(cityArray, cityIndex) in shiku">
                <i-checkbox-group :key="cityIndex" v-model="selected.shiku" style="margin-bottom: 16px;">
                  <div class="parent_name">{{ cityArray.pref_name }}</div>
                  <div v-if="cityArray.displayText" class="no_data">
                    条件に一致する市区郡がありません。
                  </div>
                  <template v-for="(item, itemIndex) in cityArray.shiku">
                    <span v-if="!item.hidden" :key="itemIndex" class="checkbox_wrap">
                      <i-checkbox :label="`${item.pref_cd}-${item.shiku_cd}`">
                        {{ item.shiku_name }}
                      </i-checkbox>
                    </span>
                  </template>
                </i-checkbox-group>
              </template>
            </div>
          </template>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onCancel">
              キャンセル
            </i-button>
            <i-button
              type="primary"
              :disabled="selected.shiku.length === 0"
              @click="onClickSearch"
              style="margin-right: 8px;"
            >
              選択エリアの全物件を表示
            </i-button>
            <i-button type="primary" :disabled="!selected.shiku.length" @click="onClickSearchChoson">
              町村を絞り込み
            </i-button>
          </div>
        </i-tab-panel>

        <!--町村選択タブ-->
        <i-tab-panel label="町村選択" :disabled="tabDisabledChoson" name="choson">
          <div v-if="modalLoading" class="loading-container">
            <i-spin fix />
          </div>
          <template v-else>
            <div style="padding-bottom: 16px;">
              <i-input
                v-model="inputSuggestChoson"
                size="small"
                search
                @on-keyup="onKeyupSuggestChoson"
                @on-keydown="onKeydownSuggestChoson"
                style="width: 200px;"
              />
              <transition>
                <span class="suggest-spin-col" v-show="loadingSuggestChoson">
                  <i-spin>
                    <i-icon type="ios-loading" size="14" class="suggest-spin-icon-load" />
                  </i-spin>
                </span>
              </transition>
            </div>
            <div class="list_wrap">
              <template v-for="(chosonArray, chosonIndex) in choson">
                <i-checkbox-group :key="chosonIndex" v-model="selected.choson" style="margin-bottom: 16px;">
                  <div class="parent_name">{{ chosonArray.shiku_name }}</div>
                  <div v-if="chosonArray.displayText" class="no_data">
                    条件に一致する町村がありません。
                  </div>
                  <template v-for="(item, itemIndex) in chosonArray.choson">
                    <span v-if="!item.hidden" :key="itemIndex" class="checkbox_wrap">
                      <i-checkbox :label="`${item.pref_cd}-${item.shiku_cd}-${item.choson_cd}`">
                        {{ item.choson_name }}
                      </i-checkbox>
                    </span>
                  </template>
                </i-checkbox-group>
              </template>
            </div>
          </template>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onCancel">キャンセル</i-button>
            <i-button
              type="primary"
              :disabled="selected.choson.length === 0"
              @click="onClickSearch"
              style="margin-right: 8px;"
            >
              選択エリアの全物件を表示
            </i-button>
            <i-button type="primary" :disabled="selected.choson.length === 0" @click="onClickSearchAza">
              丁目を絞り込み
            </i-button>
          </div>
        </i-tab-panel>

        <!--丁目選択タブ-->
        <i-tab-panel label="丁目選択" :disabled="tabDisabledAza" name="aza">
          <div v-if="modalLoading" class="loading-container">
            <i-spin fix />
          </div>
          <template v-else>
            <div style="padding-bottom: 16px;">
              <i-input
                v-model="inputSuggestAza"
                size="small"
                search
                @on-keyup="onKeyupSuggestAza"
                @on-keydown="onKeydownSuggestAza"
                style="width: 200px;"
              />
              <transition>
                <span class="suggest-spin-col" v-show="loadingSuggestAza">
                  <i-spin>
                    <i-icon type="ios-loading" size="14" class="suggest-spin-icon-load" />
                  </i-spin>
                </span>
              </transition>
            </div>
            <div class="list_wrap">
              <template v-for="(azaArray, azaIndex) in aza">
                <i-checkbox-group :key="azaIndex" v-model="selected.aza" style="margin-bottom: 16px;">
                  <div class="parent_name">{{ azaArray.choson_name }}</div>
                  <div v-if="azaArray.displayText" class="no_data">
                    条件に一致する町村がありません。
                  </div>
                  <template v-for="(item, itemIndex) in azaArray.aza">
                    <span v-if="!item.hidden" :key="itemIndex" class="checkbox_wrap">
                      <i-checkbox :label="`${item.pref_cd}-${item.shiku_cd}-${item.choson_cd}-${item.aza_cd}`">
                        {{ item.aza_name }}
                      </i-checkbox>
                    </span>
                  </template>
                </i-checkbox-group>
              </template>
            </div>
          </template>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onCancel">
              キャンセル
            </i-button>
            <i-button type="primary" :disabled="selected.aza.length === 0" @click="onClickSearch">
              絞り込み
            </i-button>
          </div>
        </i-tab-panel>
      </i-tab>
    </div>
  </i-modal>
</template>

<script>
import _ from 'lodash'
import { Modal, Button, Input, CheckboxGroup, Checkbox, Tabs, TabPane, Spin, Icon } from 'view-design'
import AddressRepository from '@/repositories/addressRepository.js'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-input': Input,
    'i-checkbox-group': CheckboxGroup,
    'i-checkbox': Checkbox,
    'i-tab': Tabs,
    'i-tab-panel': TabPane,
    'i-spin': Spin,
    'i-icon': Icon,
  },
  data() {
    return {
      modalLoading: false,
      tabValue: 'pref',
      prefs: [],
      shiku: [],
      choson: [],
      aza: [],
      selected: {
        prefs: [],
        shiku: [],
        choson: [],
        aza: [],
      },
      requestParams: {
        cds: null,
      },
      inputSuggestShiku: '',
      loadingSuggestShiku: false,
      inputSuggestChoson: '',
      loadingSuggestChoson: false,
      inputSuggestAza: '',
      loadingSuggestAza: false,
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalSearchByArea/getModal']
      },
      set(val) {
        this.$store.commit('ModalSearchByArea/setModal', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    tabDisabledShiku() {
      return this.tabValue === 'pref' ? true : false
    },
    tabDisabledChoson() {
      return this.tabValue === 'choson' || this.tabValue === 'aza' ? false : true
    },
    tabDisabledAza() {
      return this.tabValue === 'aza' ? false : true
    },
  },
  methods: {
    // モーダル開閉時処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // モーダル起動処理
        this.tabValue = 'pref'
        this.getPrefs()
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // 都道府県取得処理
    async getPrefs() {
      this.modalLoading = true
      await AddressRepository.getPrefs(true)
        .then(data => {
          if (data.result) {
            this.prefs = data.data
          }
        })
        .catch(e => {
          console.log(e)
          alert('エリアの取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 市区郡 サジェスト
    onKeyupSuggestShiku: _.debounce(function() {
      let shiku = this.shiku
      let suggestShiku = []
      let suggestText = this.inputSuggestShiku
      _.forEach(shiku, function(value) {
        let displayText = true
        let obj = {
          pref_name: value.pref_name,
          shiku: [],
        }
        _.forEach(value.shiku, function(v) {
          if (v.shiku_name.indexOf(suggestText) != -1) {
            v.hidden = false
            displayText = false
          } else {
            v.hidden = true
          }
          obj.shiku.push(v)
        })
        obj.displayText = displayText
        suggestShiku.push(obj)
      })

      this.shiku = suggestShiku
      this.loadingSuggestShiku = false
    }, 1000 * 1),
    onKeydownSuggestShiku() {
      this.loadingSuggestShiku = true
    },
    // 町村 サジェスト
    onKeyupSuggestChoson: _.debounce(function() {
      let choson = this.choson
      let suggestChoson = []
      let suggestText = this.inputSuggestChoson
      _.forEach(choson, function(value) {
        let displayText = true
        let obj = {
          shiku_name: value.shiku_name,
          choson: [],
        }
        _.forEach(value.choson, function(v) {
          if (v.choson_name.indexOf(suggestText) != -1) {
            v.hidden = false
            displayText = false
          } else {
            v.hidden = true
          }
          obj.choson.push(v)
        })
        obj.displayText = displayText
        suggestChoson.push(obj)
      })

      this.choson = suggestChoson
      this.loadingSuggestChoson = false
    }, 1000 * 1),
    onKeydownSuggestChoson() {
      this.loadingSuggestChoson = true
    },
    // 丁目 サジェスト
    onKeyupSuggestAza: _.debounce(function() {
      let aza = this.aza
      let suggestAza = []
      let suggestText = this.inputSuggestAza
      _.forEach(aza, function(value) {
        let displayText = true
        let obj = {
          choson_name: value.choson_name,
          aza: [],
        }
        _.forEach(value.aza, function(v) {
          if (v.aza_name.indexOf(suggestText) != -1) {
            v.hidden = false
            displayText = false
          } else {
            v.hidden = true
          }
          obj.aza.push(v)
        })
        obj.displayText = displayText
        suggestAza.push(obj)
      })

      this.aza = suggestAza
      this.loadingSuggestAza = false
    }, 1000 * 1),
    onKeydownSuggestAza() {
      this.loadingSuggestAza = true
    },
    // モーダル キャンセル時の処理
    onCancel() {
      this.modal = false
    },
    // タブクリック時の処理
    onClickSettingTab(name) {
      switch (name) {
        case 'pref':
          this.shiku = []
          this.choson = []
          this.aza = []
          this.selected.shiku = []
          this.selected.choson = []
          this.selected.aza = []
          break
        case 'shiku':
          this.choson = []
          this.aza = []
          this.selected.choson = []
          this.selected.aza = []
          break
        case 'choson':
          this.aza = []
          this.selected.aza = []
          break
      }
      this.tabValue = name
    },
    // エリアボタンクリック時の処理
    onClickArea(cd) {
      let selectIdx = this.selected.prefs.indexOf(cd)
      if (selectIdx === -1) {
        this.selected.prefs.push(cd)
      } else {
        this.selected.prefs.splice(selectIdx, 1)
      }
    },
    // 市区郡を絞り込みボタン クリック処理
    async onClickSearchCity() {
      this.modalLoading = true
      const prefCds = this.selected.prefs
      await AddressRepository.getShikus(prefCds)
        .then(data => {
          if (data.result) {
            let result = _.chain(data.data)
              .groupBy('pref_name')
              .toPairs()
              .map(function(currentItem) {
                return _.zipObject(['pref_name', 'shiku'], currentItem)
              })
              .value()
            this.shiku = result
            this.inputSuggestShiku = ''
            this.loadingSuggestShiku = false
            this.tabValue = 'shiku'
          }
        })
        .catch(e => {
          console.log(e)
          alert('エリアの取得に失敗しました。')
          this.onCancel()
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 町村を絞り込みボタン クリック処理
    async onClickSearchChoson() {
      this.modalLoading = true
      const cds = this.selected.shiku
      await AddressRepository.getChosons(cds)
        .then(data => {
          if (data.result) {
            let result = _.chain(data.data)
              .groupBy('shiku_name')
              .toPairs()
              .map(function(currentItem) {
                return _.zipObject(['shiku_name', 'choson'], currentItem)
              })
              .value()
            this.choson = result
            this.inputSuggestChoson = ''
            this.loadingSuggestChoson = false
            this.tabValue = 'choson'
          }
        })
        .catch(e => {
          console.log(e)
          alert('エリアの取得に失敗しました。')
          this.onCancel()
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 丁目を絞り込みボタン クリック処理
    async onClickSearchAza() {
      this.modalLoading = true
      const cds = this.selected.choson
      await AddressRepository.getAzas(cds)
        .then(data => {
          if (data.result) {
            let result = _.chain(data.data)
              .groupBy('choson_name')
              .toPairs()
              .map(function(currentItem) {
                return _.zipObject(['choson_name', 'aza'], currentItem)
              })
              .value()
            this.aza = result
            this.inputSuggestAza = ''
            this.loadingSuggestAza = false
            this.tabValue = 'aza'
          }
        })
        .catch(e => {
          console.log(e)
          alert('エリアの取得に失敗しました。')
          this.onCancel()
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 絞り込み実行
    onClickSearch() {
      let selected
      switch (this.tabValue) {
        case 'pref':
          selected = this.selected.prefs
          break
        case 'shiku':
          selected = this.selected.shiku
          break
        case 'choson':
          selected = this.selected.choson
          break
        case 'aza':
          selected = this.selected.aza
          break
        default:
          selected = []
          break
      }
      this.search.addr_cds = selected.join(',')

      this.$emit('search')
      this.modal = false
    },
    // パラメータリセット
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      // パラメータリセット
      this.prefs = []
      this.shiku = []
      this.choson = []
      this.aza = []
      this.selected.prefs = []
      this.selected.shiku = []
      this.selected.choson = []
      this.selected.aza = []
      this.inputSuggestShiku = ''
      this.loadingSuggestShiku = false
      this.inputSuggestChoson = ''
      this.loadingSuggestChoson = false
      this.inputSuggestAza = ''
      this.loadingSuggestAza = false
      this.requestParams.cds = null
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-search-area {
  .parent_name {
    font-weight: bold;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 4px;
    margin-bottom: 8px;
  }
  .list_wrap {
    max-height: 250px;
    overflow: scroll;
  }
  .checkbox_wrap {
    min-width: 120px;
    display: inline-block;
    margin-bottom: 8px;
    margin-right: 8px;
  }
  .no_data {
    font-size: 12px;
    margin: 16px 0;
  }
  .btn_wrap {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .selectgroup-button:hover {
    background-color: #9fcdff;
  }
  .modal-body {
    min-height: 180px;
    max-height: 300px;
    overflow: scroll;
  }
  .modal-footer {
    justify-content: space-between;
  }
  .form-group {
    padding-bottom: 16px;
  }
  .loading-container {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.suggest-spin {
  &-col {
    display: inline-block;
    margin-left: 8px;
  }
  &-icon-load {
    animation: suggest-spin 1s linear infinite;
  }
}

@keyframes suggest-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
